import useTranslation from '@space-core/hooks/useTranslation'
import { Helmet } from 'react-helmet-async'

export type HtmlHeadProps = {
  title: string
  url?: string
  author?: string
  description?: string
  og?: {
    image?: string
  }
}

const HtmlHead = ({ title, url, description, author, og }: HtmlHeadProps) => {
  const { t } = useTranslation()
  const configuredTitle = `${title} | Hotmart Club`

  const configuredMeta = [
    { name: 'description', content: description },
    { name: 'abstract', content: description },
    { name: 'author', content: author },
    { property: 'og:url', content: url },
    { property: 'og:description', content: description },
    { property: 'og:author', content: author },
    { property: 'og:type', content: 'website' },
    { property: 'og:image', content: og?.image },
    { property: 'og:title', content: configuredTitle },
    { property: 'og:site_name', content: t('meta.site_name') }
  ]

  return (
    <Helmet>
      <title key='title'>{configuredTitle}</title>
      <link rel='canonical' href={url ?? window.location.href} />

      {configuredMeta.map((meta, index) => {
        return meta.content ? <meta key={index} {...meta} /> : null
      })}
    </Helmet>
  )
}

export default HtmlHead
